import React from "react";
import { GoDotFill } from "react-icons/go";

import { FaStar, FaQuoteRight } from "react-icons/fa";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import TestimonialCarousel from "./testomonialCarousel";

const SectionSix = () => {
  return (
    <div className=" bg-white">
      <div className="px-6 py-8 md:p-16 xl:px-32 xl:py-24 bg-[#FCFCFC]">
        <div className=" gap-4 md:gap-6">
          <button className="flex items-center justify-center gap-1 mx-auto mb-4 text-[#32AE4C] border border-[#32AE4C] tracking-wider px-2 md:px-4 py-1 md:py-1 lg:py-1 rounded-full text-xs md:text-xs  xl:text-sm ">
            <GoDotFill className="w-3 h-3 lg:w-4 lg:h-4" />
            API Integration
          </button>
          <p className="text-[#202020] text-center font-bold text-sm lg:text-base xl:text-2xl tracking-wider">
            Build custom payments experiences with our structured <br />{" "}
            documented APIs
          </p>

          <div className="flex flex-col md:flex-row  items-center mt-4  ">
            <div className=" w-full md:w-[50%] flex flex-col items-center justify-center ">
              <img
                src={"./assets/circular.svg"}
                alt="circular-img"
                className=" w-full  animate-spin-slow    h-[240px] lg:h-[380px] xl:h-[420px]"
              />
            </div>

            <div className=" w-full md:w-[50%] flex flex-col px-[4px] py-5 md:py-10 md:px-4  lg:p-10 gap-4 md:gap-8 lg:gap-4 ">
              <div className="flex flex-col gap-2 md:gap-4 lg:gap-4">
                <div className="flex items-center gap-1">

                     <img
                  src={"./assets/tick-circle.svg"}
                  alt="circular-img"
                  className="w-5 h-5  lg:w-6 lg:h-6 "
                />
                <p className="text-sm md:text-base lg:text-lg xl:text-xl font-semibold">
                  Transfer API
                </p>
                </div>
             
                <p className="text-xs md:text-sm lg:text-sm w-[80%]  text-gray-500">
                  Automatically transfer money directly to your customers bank
                  accounts.
                </p>
              </div>
              <div className="flex flex-col gap-2 md:gap-4 lg:gap-4">
                                <div className="flex items-center gap-1">

                <img
                  src={"./assets/tick-circle.svg"}
                  alt="circular-img"
                  className="w-5 h-5  lg:w-6 lg:h-6 "
                />
                <p className="text-sm md:text-base lg:text-lg xl:text-xl font-semibold">
                  Webhook-Driven:
                </p>
                </div>
                <p className="text-xs md:text-sm lg:text-sm w-[80%]  text-gray-500">
                  Real‑time events for successful transactions, disputes, and
                  balance updates
                </p>
              </div>
               <div className="flex flex-col gap-2">
                                <div className="flex items-center gap-1">

                <img
                  src={"./assets/tick-circle.svg"}
                  alt="circular-img"
                  className="w-5 h-5  lg:w-6 lg:h-6 "
                />
                <p className="text-sm md:text-base lg:text-lg xl:text-xl font-semibold">
                PCI‑Level Security: 
                </p>
                </div>
                <p className="text-xs md:text-sm lg:text-sm w-[80%]  text-gray-500">
Tokenization, encryption, and built‑in fraud rules out of the box                </p>
              </div>
              <div className="flex flex-col gap-2">
                                <div className="flex items-center gap-1">

                <img
                  src={"./assets/tick-circle.svg"}
                  alt="circular-img"
                  className="w-5 h-5  lg:w-6 lg:h-6 "
                />
                <p className="text-sm md:text-base lg:text-lg xl:text-xl font-semibold">
                Comprehensive Docs: 
                </p>
                </div>
                <p className="text-xs md:text-sm lg:text-sm w-[80%]  text-gray-500">
                  Interactive examples, SDK snippets, and “Try It Now” sandboxes
                </p>
              </div>

              <a
                href="https://vantpapi.readme.io/reference/getting-started-with-your-api"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="bg-[#32AE4C] whitespace-nowrap text-white px-4 py-2 md:py-3 rounded-full text-xs md:text-ssm lg:text-sm max-w-[200px] mt-4 md:mt-6 lg:mt-10">
                  Read Our Documentation
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row  px-6 py-8 md:px-16 md:py-16 xl:px-32 xl:py-24 bg-[#FCFCFC] gap-4 md:gap-10">
        <div className="flex-1 lg:flex-2 flex flex-col gap-6 ">
          <div className="flex justify-center lg:justify-start">
            <button className="flex items-center justify-center gap-1 text-[#32AE4C] border border-[#32AE4C] tracking-wider px-2 md:px-4 py-1 md:py-1 lg:py-1 rounded-full text-xs md:text-xs  xl:text-sm ">
              <GoDotFill className="w-3 h-3  lg:w-4 lg:h-4" />
              <p className="whitespace-now-rap">Testimonies</p>
            </button>
          </div>
          <p className="text-[#202020] font-bold text-base md:text-lg lg:text-2xl xl:text-2xl tracking-wider ">
            Discover Why Vant is Their <br className="hidden lg:block" /> Go-To
            Choice
          </p>
          <div className="mt-4 md:mt-10 hover:scale-100">
            <img
              src={"./assets/map.svg"}
              alt="map-img"
              className="hover:translate-x-5 transition-all ease-in-out duration-200"
            />
          </div>
        </div>
        <div className=" flex-1 flex flex-col justify-end">
          <TestimonialCarousel />
        </div>
      </div>
    </div>
  );
};

export default SectionSix;
